var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.spinning)?_c('div',{staticClass:"loading-content"},[_c('img',{attrs:{"src":require("../assets/imgs/loading.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.TLang('加载中', 'result'))+"...")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }